import { ModuleProps } from '../common/container/module'
import { Container, ContainerItem } from '../common/container/Container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { ProtocolApi } from '../modules/protocols/api/ProtocolApi'
import { ProtocolService } from '../modules/protocols/services/ProtocolService'
import { PROTOCOL_API_KEY, PROTOCOL_MODULE, PROTOCOL_SERVICE_KEY } from '../modules/protocols'

let container: Container

function init(p: ModuleProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(PROTOCOL_API_KEY, new ContainerItem({ instance: new ProtocolApi() }))

  items.set(
    PROTOCOL_SERVICE_KEY,
    new ContainerItem({ instance: new ProtocolService({ apiKey: PROTOCOL_API_KEY }) })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getProtocolContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[PROTOCOL_MODULE],
      },
    })
  }

  return container
}
